export const isBitSet = (x: number, b: number): boolean => !!(x & (1 << (b - 1)))
